import { CartItem } from "@/src/store/useCartStore";
import { get, put } from "../apiHandler";

/** سفارش باز کاربر (null یعنی وجود ندارد) */
export const fetchActiveSale = async () => await get("/sale-check"); // GET

/** ایجاد یا به‌روزرسانی سفارش باز */
export const upsertSale = async (payload: {
  sale_first_name?: string;
  sale_last_name?: string;
  sale_mobile?: string;
  sale_address?: string;
  sale_city?: string;
  sale_province?: string;
  sale_phone?: string;
  sale_postal_code?: string;
  sale_description?: string;
  products: CartItem[];
}) =>
  await put("/sale-check", {
    ...payload,
    products: JSON.stringify(payload.products),
  }); // PUT
